// extracted by mini-css-extract-plugin
export default {"dialog":"JiLlR2NMNcczbLdp"};